import { AuthService } from "@/services";
import { mapActions } from "vuex";
import * as types from "./../../../store/types";

export default {
  name: "register-verification",
  components: {},
  props: [],
  data() {
    return {
      otpCode: "",
      loading: false,
      repeatLoading: false,
      countdownTimer: "",
      isCounterExpired: false,
      clockInterval: "",
      otpRules: [
        v =>
          !!v ||
          this.$t(
            "authPage.registerVerificationPage.verificationCode.validation"
          )
      ],
      valid: false
    };
  },
  computed: {
    otpToken() {
      return localStorage.getItem("otpToken");
    },
    emailOrMobile() {
      return localStorage.getItem("emailOrMobile");
    },
    ttl() {
      return localStorage.getItem("ttl");
    }
  },
  mounted() {
    this.countdown(this.ttl);
  },
  methods: {
    ...mapActions({
      checkIsAuth: types.auth.actions.ACTION_CHECK_IS_AUTH
    }),
    countdown(distance) {
      distance = distance / 1000;
      this.clockInterval = setInterval(() => {
        distance--;
        let minutes = Math.floor(distance / 60);
        let seconds = Math.floor(distance % 60);
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        if (seconds < 10) {
          seconds = "0" + seconds;
        }
        let x = minutes + ":" + seconds;
        if (distance < 0) {
          this.countdownTimer = "00:00";
          this.isCounterExpired = true;
          clearInterval(this.clockInterval);
        } else {
          this.countdownTimer = x;
        }
      }, 1000);
    },
    onSubmit() {
      this.loading = true;
      if (this.$refs.form.validate()) {
        this.verifyRegistration();
      } else {
        this.loading = false;
      }
    },
    verifyRegistration() {
      let otpToken = localStorage.getItem("otpToken");
      let GACID = this.$cookies.get("_ga");
      AuthService.verifyRegister(this.otpCode, otpToken, GACID)
        .then(() => {
          // localStorage.setItem("accessToken", response.data.data.token);
          // localStorage.setItem("isAuth", true);
          // this.checkIsAuth();
          this.$router.push("/auth/register/go-for-signin");
        })
        .catch(error => {
          this.$toast.error(error.response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resendOtpCode() {
      this.repeatLoading = true;
      let otpToken = localStorage.getItem("otpToken");
      AuthService.resendRegisterOtp(otpToken)
        .then(response => {
          localStorage.setItem("otpToken", response.data.data.otp_token);
          this.countdown(response.data.data.ttl);
          this.isCounterExpired = !this.isCounterExpired;
          this.$toast.success(response.data.message);
        })
        .catch(error => {
          this.$toast.error(error.response.data.message);
        })
        .finally(() => {
          this.repeatLoading = false;
        });
    }
  }
};
